import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountingEvent  {
    _originalTypeClassName = "zERP.BO.AccountingEvent";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountingEvent.translate = translateService;
}
this.OveriddenBy = [];
this.AccountingEventID = null;
this.Name = null;
this.Description = null;
this.SystemId = null;
this.DontTriggerAutomatically = false;
this._key = this.AccountingEventID = 0; 
}

static translate: TranslateService;
_key: any;
private _AccountingEventID:any;
get AccountingEventID(): any {
    return this._AccountingEventID;
  }
set AccountingEventID(value: any) {
    this._AccountingEventID = value;
    this._key = value;
  }
Name:any;
Description:any;
SystemId:any;
DontTriggerAutomatically:any;
Entity:any;
InvoiceSelectionCriteria:any;
OveriddenBy:any;
Override:any;
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setInvoiceSelectionCriteria = ($this, value) => {
var oldValue = $this.InvoiceSelectionCriteria;
$this.InvoiceSelectionCriteria = value;
if (value != null) {
}
}
static setOveriddenBy = ($this, items) => {
                if (items == null) items = [];
                if ($this.OveriddenBy == null) $this.OveriddenBy = [];

                const copyItems = Common.cloneObject(items);

                while ($this.OveriddenBy.length > 0) {
                    Domain.AccountingEvent.removeOveriddenBy($this, $this.OveriddenBy[0]);
                }

                Domain.AccountingEvent.addManyOveriddenBy($this, copyItems);
            }
static addManyOveriddenBy = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountingEvent.addOveriddenBy($this, items[i]);
                }
            }
static addOveriddenBy = ($this, item) => {
                if ($this.OveriddenBy == null) $this.OveriddenBy = [];
                if (item == null || $this.OveriddenBy.indexOf(item) > -1) return;
                $this.OveriddenBy.push(item);
if (item.Override != $this) {
Domain.AccountingEvent.setOverride(item, $this);
}
}
static addRangeOveriddenBy = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountingEvent.addOveriddenBy($this, item));
            }
static removeOveriddenBy = ($this, item) => {
                if ($this == null || $this.OveriddenBy == null || $this.OveriddenBy.indexOf(item) === -1) return;
                var _index = $this.OveriddenBy.indexOf(item);
                $this.OveriddenBy.splice(_index, 1);
item.Override = null;
}
static clearOveriddenBy = ($this) => { $this.OveriddenBy = null; }
static setOverride = ($this, value) => {
var oldValue = $this.Override;
$this.Override = value;
if (value != null) {
if (oldValue != null) {
Domain.AccountingEvent.removeOveriddenBy(oldValue, $this);
}
Domain.AccountingEvent.addOveriddenBy(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AccountingEventID == null || $this.AccountingEventID == 0;
            }


}